import React, {PureComponent} from 'react';
import * as ReactGA from '../../GA';
import {Menu, MenuItem} from '../../atoms/Menu';
import './Switchlock.css';
import TranslatedText from '../../atoms/TranslatedText';
import {ROUTES} from '../../routes';
import videos from './video';
import i18n from '../../locales/i18n';
import Video from '../../atoms/Video';

const MENU = {
    'airbrake-snow': {
        title: 'switchlock.airbrake_snow.title',
        description: 'switchlock.airbrake_snow.description',
        poster: require('./airbrake-snow-poster.png'),
        install: 0,
        remove: 1,
    },
    'airbrake-mx': {
        title: 'switchlock.airbrake_mx.title',
        description: 'switchlock.airbrake_mx.description',
        poster: require('./airbrake-mx-poster.png'),
        install: 2,
        remove: 3,
    },
    jawbreaker: {
        title: 'switchlock.jawbreaker.title',
        description: 'switchlock.jawbreaker.description',
        poster: require('./jawbreaker-poster.png'),
        install: 4,
        remove: 5,
    },
};

export default class Switchlock extends PureComponent {
    state = {type: this.props.match.params.type, state: null};

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.type !== state.type) {
            return {type: props.match.params.type, state: null};
        }

        return null;
    }
    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/Switchlock/${this.props.match.params.type}`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/Switchlock/${this.props.match.params.type}/${
                this.state.state ? this.state.state : ''
            }`
        );
    }

    render() {
        const type = this.props.match.params.type;
        const history = this.props.history;

        const currentType = MENU[type];
        const video = videos[i18n.language][currentType[this.state.state]];

        let videoEl;
        let style;

        if (video) {
            videoEl = (
                <Video
                    className="Switchlock-video"
                    src={video}
                    poster="data:image/gif,AAAA"
                    style={{backgroundImage: `url(${currentType.poster})`}}
                    autoPlay
                    playsInline
                    muted
                    loop
                />
            );
        } else {
            style = {backgroundImage: `url(${currentType.poster})`};
        }

        return (
            <article className="Switchlock" style={style}>
                {videoEl}
                <div className="Switchlock-content">
                    <h3>
                        <TranslatedText tag={currentType.title} />
                    </h3>
                    <div className="Switchlock-buttons">
                        <button
                            onClick={() =>
                                this.setState({
                                    state: 'remove',
                                })
                            }
                            className={
                                this.state.state === 'remove'
                                    ? 'active'
                                    : 'default'
                            }>
                            <TranslatedText tag="switchlock.removing_lens" />
                        </button>
                        <button
                            onClick={() =>
                                this.setState({
                                    state: 'install',
                                })
                            }
                            className={
                                this.state.state === 'install'
                                    ? 'active'
                                    : 'default'
                            }>
                            <TranslatedText tag="switchlock.installing_lens" />
                        </button>
                    </div>
                    {this.state.state === null && (
                        <h4>
                            <TranslatedText tag={currentType.description} />
                        </h4>
                    )}
                </div>

                <Menu>
                    <MenuItem
                        tag="switchlock.menu.airbrake-snow"
                        onClick={() =>
                            history.push(ROUTES.SWITCHLOCK_AIRBRAKESNOW)
                        }
                        active={this.state.type === 'airbrake-snow'}
                    />
                    <MenuItem
                        tag="switchlock.menu.airbrake-mx"
                        onClick={() =>
                            history.push(ROUTES.SWITCHLOCK_AIRBRAKEMX)
                        }
                        active={this.state.type === 'airbrake-mx'}
                    />
                    <MenuItem
                        tag="switchlock.menu.jawbreaker"
                        onClick={() =>
                            history.push(ROUTES.SWITCHLOCK_JAWBREAKER)
                        }
                        active={this.state.type === 'jawbreaker'}
                    />
                </Menu>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/switchlock/Switchlock.js